import { BookOutlined, CheckCircleOutlined, CopyOutlined, EditOutlined, FileTextOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarConceptoNomina from "./AgregarConceptoNomina/AgregarConceptoNomina";
import EditarConceptoNomina from "./EditarConceptoNomina/EditarConceptoNomina";
import GuiaFormulas from "./GuiaFormulas/GuiaFormulas";
import GuiaConceptosLey from "./GuiaConceptosLey/GuiaConceptosLey";

moment.locale("es");

const TIPO_LABELS = {
  1: { label: "Percepción", color: "green" },
  2: { label: "Deducción", color: "red" },
  3: { label: "Obligación", color: "blue" },
};

class ConceptosNomina extends Component {
  tableRef = null;
  state = {
    todosConceptos: [],
    loading: false,
    valor: 1,
    modalAgregarConcepto: false,
    modalAgregarConceptoOrigenId: null,
    modalEditarConcepto: false,
    modalEditarConceptoId: null,
    guiaFormulas: false,
    guiaConceptosLey: false,
  };

  consultarConceptos(params) {
    this.setState({ loading: true });
    axios
      .post(
        "conceptosNomina/selectTodasConceptosNomina",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todosConceptos: [] });
        } else {
          this.setState({ todosConceptos: res.data.data, totalRecords: res.data.totalRecords || 0 });
        }
      });
  }

  deshabilitarConcepto(value) {
    axios
      .post(
        "conceptosNomina/deshabilitarConceptoNomina",
        { conceptoNominaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) message.success("Concepto deshabilitado");
        else message.error("No se pudo deshabilitar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  habilitarConcepto(value) {
    axios
      .post(
        "conceptosNomina/habilitarConceptoNomina",
        { conceptoNominaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) message.success("Concepto habilitado");
        else message.error("No se pudo habilitar");
        if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  }

  agregarConcepto() { this.setState({ modalAgregarConcepto: true, modalAgregarConceptoOrigenId: null }); }

  // Duplicar reutiliza el modal de Agregar, precargado con los datos del concepto origen
  duplicarConcepto(id) { this.setState({ modalAgregarConcepto: true, modalAgregarConceptoOrigenId: id }); }

  cerrarAgregarConcepto() {
    this.setState({ modalAgregarConcepto: false, modalAgregarConceptoOrigenId: null });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  editarConcepto(id) { this.setState({ modalEditarConcepto: true, modalEditarConceptoId: id }); }
  cerrarEditarConcepto() {
    this.setState({ modalEditarConcepto: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  render() {
    const columns = [
      {
        title: "N°",
        dataIndex: "numeroConcepto",
        key: "numeroConcepto",
        width: "5%",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        buscar: "descripcion",
        width: "18%",
      },
      {
        title: "Tipo",
        dataIndex: "tipo",
        key: "tipo",
        width: "9%",
        render: (value) => {
          const t = TIPO_LABELS[value];
          return t ? <Tag color={t.color}>{t.label}</Tag> : "—";
        },
      },
      {
        title: "Nombre Importe Total",
        dataIndex: "nombreImporteTotal",
        key: "nombreImporteTotal",
        buscar: "nombreImporteTotal",
        width: "14%",
      },
      {
        title: "Tipo Percepción SAT",
        dataIndex: "tipoPercepcionSat",
        key: "tipoPercepcionSat",
        width: "14%",
        render: (value) => value || "—",
      },
      {
        title: "Flags",
        key: "flags",
        width: "12%",
        render: (_, record) => (
          <span style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            {record.automaticoGlobal && <Tag color="cyan">Auto Global</Tag>}
            {record.automaticoLiquidacion && <Tag color="purple">Auto Liq.</Tag>}
            {record.especie && <Tag color="orange">Especie</Tag>}
            {record.imprimir && <Tag>Imprimir</Tag>}
          </span>
        ),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "7%",
        render: (value) => {
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        key: "accion",
        width: "12%",
        render: (_, record) => {
          const buttons = [];
          buttons.push(
            <Tooltip key={`editar-${record._id}`} title="Editar Concepto" placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
              <ButtonItem type="default" size="small" cyan icon={<EditOutlined />}
                onClick={() => this.editarConcepto(record._id)} />
            </Tooltip>
          );
          buttons.push(
            <Tooltip key={`duplicar-${record._id}`} title="Duplicar Concepto" placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
              <ButtonItem type="default" size="small" icon={<CopyOutlined />}
                onClick={() => this.duplicarConcepto(record._id)} />
            </Tooltip>
          );
          if (record.estado === 1) {
            buttons.push(
              <Popconfirm key={`deshabilitar-${record._id}`}
                title="¿Deshabilitar este concepto?"
                onConfirm={() => this.deshabilitarConcepto(record._id)}
                okText="Sí" cancelText="No">
                <Tooltip title="Deshabilitar" placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                  <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm key={`habilitar-${record._id}`}
                title="¿Habilitar este concepto?"
                onConfirm={() => this.habilitarConcepto(record._id)}
                okText="Sí" cancelText="No">
                <Tooltip title="Habilitar" placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}>
                  <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          }
          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Conceptos de Nómina"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[{ label: "Vigente", value: 1 }, { label: "Deshabilitado", value: 2 }, { label: "Todos", value: 3 }]}
                  onChange={(value) => {
                    if (this.tableRef) this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <Tooltip title="Qué dice la ley de cada concepto, si grava o exenta, y con qué fórmulas darlo de alta">
                <ButtonItem
                  type="default"
                  key="guiaConceptosLey"
                  icon={<FileTextOutlined />}
                  onClick={() => this.setState({ guiaConceptosLey: true })}
                >
                  Guía Legal
                </ButtonItem>
              </Tooltip>
              <Tooltip title="Cómo se arman las fórmulas, qué variables existen y para qué sirve cada importe">
                <ButtonItem
                  type="default"
                  key="guiaFormulas"
                  icon={<BookOutlined />}
                  onClick={() => this.setState({ guiaFormulas: true })}
                >
                  Guía de Fórmulas
                </ButtonItem>
              </Tooltip>
              <ButtonItem type="primary" key="agregarConcepto" onClick={this.agregarConcepto.bind(this)}>
                Agregar Concepto
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarConceptos.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          dataSource={this.state.todosConceptos}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"conceptosNomina" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => this.editarConcepto(record._id),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <AgregarConceptoNomina
          visible={this.state.modalAgregarConcepto}
          conceptoOrigenId={this.state.modalAgregarConceptoOrigenId}
          cerrarAgregarConceptoNomina={this.cerrarAgregarConcepto.bind(this)}
        />
        <EditarConceptoNomina
          visible={this.state.modalEditarConcepto}
          conceptoNominaId={this.state.modalEditarConceptoId}
          cerrarEditarConceptoNomina={this.cerrarEditarConcepto.bind(this)}
        />
        <GuiaFormulas
          visible={this.state.guiaFormulas}
          onClose={() => this.setState({ guiaFormulas: false })}
        />
        <GuiaConceptosLey
          visible={this.state.guiaConceptosLey}
          onClose={() => this.setState({ guiaConceptosLey: false })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConceptosNomina);